const baseUrl = (import.meta.env.VITE_MW_ZENTO_URL || '').replace(/\/$/, '')
const apiKey = import.meta.env.VITE_MW_ZENTO_API_KEY || ''

async function request(path, options = {}) {
  if (!baseUrl) {
    throw new Error('El servicio de Chile no está configurado')
  }
  const response = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': apiKey,
      ...(options.headers || {})
    }
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    throw new Error(data.error || 'No se pudo consultar el servicio de Chile')
  }
  return data
}

export function getChileBalance() {
  return request('/balance')
}

export function getChileMovements({ direction = 'all', page = 1, pageSize = 100, dateFrom, dateTo, amount, paymentMethod, id, merchantReference } = {}) {
  const params = new URLSearchParams({ direction, page: String(page), pageSize: String(pageSize) })
  if (dateFrom) params.set('dateFrom', dateFrom)
  if (dateTo) params.set('dateTo', dateTo)
  if (amount) params.set('amount', amount)
  if (paymentMethod) params.set('paymentMethod', paymentMethod)
  if (id) params.set('id', id)
  if (merchantReference) params.set('merchantReference', merchantReference)
  return request(`/movements?${params.toString()}`)
}

export function getChileTransferConfig() {
  return request('/config/transfer')
}

export function getChileReceiveConfig() {
  return request('/config/receive')
}

export function createChileCollection(body) {
  return request('/collections', {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

export function getChileCollection(id) {
  return request(`/collections/${encodeURIComponent(id)}`)
}

export function createChileTransfer(body, idempotencyKey) {
  return request('/transfers', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {}
  })
}

export function waitChileTransfer(id, signal) {
  return request(`/transfers/${encodeURIComponent(id)}/wait`, { signal })
}
